import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'SALVA E AGGIUNGI, OPPURE ANNULLA',
        description:
            "Una volta completata la creazione dell'esercizio, clicca su 'Salva e aggiungi' per salvarlo ed aggiungerlo alla tua verifica, oppure clicca su 'Annulla' per annullare le modifiche fatte.",
        isActive: true,
        name: 'CreationSavePageAnchor',
        tutorialName: 'creazione-esercizi_pulsantiera-salvataggio'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top',
        xOffset: 5
    }
};
